<template lang="pug">
  include /mixins
  div
    slot()
      +b.circle-btn.--variant_2.A(:href='$options.url')
        +e.icon.--color_1.icon-like.SPAN
</template>

<script>
export default {
  name: 'FavoritePreview',

  // url: `${window.baseUrl}filters/favorite=true/`,
  url: `${window.profileUrl}favorites/product/`,
}
</script>
